import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const paragraphFn = /* @__PURE__ */ createRecipe('Paragraph', {}, [])

const paragraphVariantMap = {}

const paragraphVariantKeys = Object.keys(paragraphVariantMap)

export const paragraph = /* @__PURE__ */ Object.assign(memo(paragraphFn.recipeFn), {
  __recipe__: true,
  __name__: 'paragraph',
  __getCompoundVariantCss__: paragraphFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: paragraphVariantKeys,
  variantMap: paragraphVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, paragraphVariantKeys)
  },
  getVariantProps: paragraphFn.getVariantProps,
})